module.exports = __webpack_public_path__ + "static/media/axisArrow-dark.07a4a05d.svg";